export const AUTH_API_HOSTNAME = 'api.auth.autone.io';
